import { TuiLinks } from '../models/constants';
export var CalloutDeclarations = {
    App_PinningWizard_Callout: {
        targetElementId: 'AppBar_AppsButton',
        impressionEvent: "Callout_Apps_Module_With_Pinning_Wizard" /* KnownImpressionInstrumentationEvents.CalloutAppsModuleWithPinningWizardImpression */,
        content: {
            title: 'appModuleCalloutWithPinningWizardTitle',
            text: 'appModuleCalloutWithPinningWizardText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-apps_light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-apps_dark',
                    fileExtension: 'svg',
                },
            },
        },
        directionalHint: 'rightTopEdge',
        page: 'Any',
    },
    AppBar_Module_Callout: {
        targetElementId: 'AppBar_AppsButton',
        impressionEvent: "Callout_Apps_Button" /* KnownImpressionInstrumentationEvents.CalloutAppsButtonImpression */,
        content: {
            title: 'appModuleCalloutTitle',
            text: 'appModuleCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-apps_light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-apps_dark',
                    fileExtension: 'svg',
                },
            },
        },
        directionalHint: 'rightTopEdge',
        page: 'Any',
    },
    AppBar_Pinning_Callout: {
        targetElementId: 'AppGallery_ContextMenu',
        impressionEvent: "Callout_App_Bar_Pinning" /* KnownImpressionInstrumentationEvents.CalloutAppBarPinningImpression */,
        page: 'AppGallery',
        content: {
            title: 'appGalleryPinningCalloutTitle',
            text: 'appGalleryPinningCalloutText',
        },
        directionalHint: 'bottomCenter',
    },
    AppBar_Module_With_Privacy_Callout: {
        targetElementId: 'AppBar_AppsButton',
        impressionEvent: "Callout_Apps_Module_With_Privacy" /* KnownImpressionInstrumentationEvents.CalloutAppsModuleWithPrivacyImpression */,
        content: {
            title: 'appModuleCalloutTitle',
            text: 'appModuleCalloutWithPrivacyText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-apps_light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-apps_dark',
                    fileExtension: 'svg',
                },
            },
        },
        directionalHint: 'rightTopEdge',
        page: 'Any',
    },
    Admin_Acquired_Apps_Callout: {
        // TODO 7656082 Anchor to ... if no space
        targetElementId: 'AppBar_AppsButton',
        impressionEvent: "Callout_Admin_Acquired_Apps" /* KnownImpressionInstrumentationEvents.CalloutAdminAcquiredAppsImpression */,
        content: {
            title: 'adminAcquiredAppsCalloutTitle',
            text: 'adminAcquiredAppsCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-admin-acquired-apps-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-admin-acquired-apps-dark',
                    fileExtension: 'svg',
                },
            },
        },
        directionalHint: 'rightTopEdge',
        page: 'Any',
    },
    EdgeworthConsumer_Favorites_Callout: {
        targetElementId: 'Edgeworth_Favorite',
        impressionEvent: "Callout_Edgeworth_Consumer_Favorites" /* KnownImpressionInstrumentationEvents.CalloutEdgeworthConsumerFavoritesImpression */,
        content: {
            title: 'edgeworthPinnedFavoritesCalloutTitle',
            text: 'edgeworthPinnedFavoritesCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-pinned-to-favorties_light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-pinned-to-favorites_dark',
                    fileExtension: 'svg',
                },
            },
        },
        page: 'HomePage',
        directionalHint: 'topCenter',
    },
    EdgeworthConsumer_MyContent_Callout: {
        targetElementId: 'AppBar_MyContent',
        impressionEvent: "Callout_Consumer_MyContent" /* KnownImpressionInstrumentationEvents.CalloutConsumerMyContentImpression */,
        content: {
            title: 'manageContentCalloutTitle',
            text: 'manageContentConsumerCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-my-content-consumer_light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-my-content-consumer_dark',
                    fileExtension: 'svg',
                },
            },
        },
        directionalHint: 'rightTopEdge',
        page: 'HomePage',
    },
    Create_Here_Consumer_Callout: {
        targetElementId: 'AppBar_CreateCenter',
        impressionEvent: "Callout_Create_Here" /* KnownImpressionInstrumentationEvents.CalloutCreateHereImpression */,
        page: 'HomePage',
        directionalHint: 'rightTopEdge',
        content: {
            title: 'createHereCalloutTitle',
            text: 'createHereCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-create-consumer-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-create-consumer-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Create_Here_Commercial_Callout: {
        targetElementId: 'AppBar_CreateCenter',
        impressionEvent: "Callout_Create_Here" /* KnownImpressionInstrumentationEvents.CalloutCreateHereImpression */,
        page: 'HomePage',
        directionalHint: 'rightTopEdge',
        content: {
            title: 'createHereCalloutTitle',
            text: 'createHereCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-create-commercial-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-create-commercial-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Manage_Content_Commercial_Callout: {
        targetElementId: 'AppBar_MyContent',
        impressionEvent: "Callout_Commercial_MyContent" /* KnownImpressionInstrumentationEvents.CalloutCommercialMyContentImpression */,
        page: 'HomePage',
        directionalHint: 'rightTopEdge',
        content: {
            title: 'manageContentCalloutTitle',
            text: 'manageContentCommercialCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-manage-content-commercial-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-manage-content-commercial-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Feed_Callout: {
        targetElementId: 'AppBar_Feed',
        impressionEvent: "Callout_Feed" /* KnownImpressionInstrumentationEvents.CalloutFeedImpression */,
        page: 'HomePage',
        directionalHint: 'rightTopEdge',
        content: {
            title: 'feedCalloutTitle',
            text: 'feedCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-feed-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-feed-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Visio_Library_Tile_Callout: {
        targetElementId: 'Visio_Library_Tile',
        impressionEvent: "Visio_Library_Tile_Impression" /* KnownImpressionInstrumentationEvents.VisioLibraryTileImpression */,
        page: 'Start',
        directionalHint: 'bottomCenter',
        content: {
            title: 'visioLibraryTileCalloutTitle',
            text: 'visioLibraryTileCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'visio-landing-page-tui-callout-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'visio-landing-page-tui-callout-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Upload_Content_Callout: {
        targetElementId: 'Edgeworth_UploadButton',
        impressionEvent: "Callout_Upload_Content" /* KnownImpressionInstrumentationEvents.CalloutUploadContentImpression */,
        page: 'HomePage',
        directionalHint: 'rightBottomEdge',
        content: {
            title: 'uploadContentCalloutTitle',
            text: 'uploadContentCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-upload-content-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-upload-content-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Consumer_Upgrade_Callout: {
        targetElementId: 'Install_GoPremiumButton',
        impressionEvent: "Callout_Consumer_Upgrade" /* KnownImpressionInstrumentationEvents.CalloutConsumerUpgradeImpression */,
        page: 'HomePage',
        directionalHint: 'bottomRightEdge',
        content: {
            title: 'consumerUpgradeCalloutTitle',
            text: 'consumerUpgradeCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-upgrade-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-upgrade-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Download_Apps_Callout: {
        targetElementId: 'Install_AppsButton',
        impressionEvent: "Callout_Download_Apps" /* KnownImpressionInstrumentationEvents.CalloutDownloadAppsImpression */,
        page: 'HomePage',
        directionalHint: 'bottomRightEdge',
        content: {
            title: 'downloadAppsCalloutTitle',
            text: 'downloadAppsCalloutText',
        },
    },
    All_Set_Callout: {
        targetElementId: 'Feedback_Button',
        impressionEvent: "Callout_All_Set" /* KnownImpressionInstrumentationEvents.CalloutAllSetImpression */,
        page: 'OfficeHome',
        directionalHint: 'topRightEdge',
        content: {
            title: 'allSetCalloutTitle',
            text: 'allSetCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-all-set-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-all-set-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
    Visuals_DarkMode_Callout: {
        targetElementId: 'Shell_Settings',
        impressionEvent: "Callout_Visuals_Dark_Mode_1" /* KnownImpressionInstrumentationEvents.CalloutVisualsDarkModeImpression */,
        // TODO: Replace with actual text
        content: {
            title: 'darkModeConsumerCalloutTitle',
            text: 'darkModeConsumerCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-dark-mode-consumer-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-dark-mode-consumer-light',
                    fileExtension: 'svg',
                },
            },
        },
        page: 'Any',
    },
    Add_Content_Callout: {
        targetElementId: 'MyContent_AddContent',
        impressionEvent: "Callout_Add_Content" /* KnownImpressionInstrumentationEvents.CalloutAddContentImpression */,
        content: {
            title: 'addContentCalloutTitle',
            text: 'addContentCalloutText',
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-add_content-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-add_content-dark',
                    fileExtension: 'svg',
                },
            },
        },
        page: 'MyContent',
    },
    Callout_Consumer_Get_Premium: {
        targetElementId: 'Install_GoPremiumButton',
        impressionEvent: "Callout_Consumer_Get_Premium" /* KnownImpressionInstrumentationEvents.CalloutConsumerGetPremiumImpression */,
        page: 'HomePage',
        directionalHint: 'bottomRightEdge',
        content: {
            title: 'upgradeToPremiumCalloutTitle',
            text: 'upgradeToPremiumCalloutText',
            urlDisplayText: 'upgradeToPremiumLearnMoreLink',
            url: TuiLinks.freemiumTuiRemindURL,
        },
        image: {
            type: 'cdn',
            imageInfo: {
                light: {
                    fileName: 'tui-upgrade-light',
                    fileExtension: 'svg',
                },
                dark: {
                    fileName: 'tui-upgrade-dark',
                    fileExtension: 'svg',
                },
            },
        },
    },
};
//# sourceMappingURL=callout-declarations.js.map